export function isCrossApp (feature) {
    return Array.isArray(feature?.appIds) && feature.appIds.length > 1;
}
